//
//
//
//
//

import Chart from "chart.js";

export default {
  name: "DoubleLine",
  props: {
    height: {
      type: Number,
      default: 200
    },

    legend: {
      type: Boolean,
      default: false
    },

    labels: {
      type: Array,
      default: () => []
    },

    baseline: {
      type: Object,
      default: () => {
      }
    },

    dataset: {
      type: Object,
      default: () => {
      }
    },
  },

  data: () => ({
    chart: {}
  }),

  computed: {
    chartOptions() {
      return {
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
            },
            gridLines: {
              display: true,
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
            },
            ticks: {
              beginAtZero: true,
              stepSize: 0.2,
            },
            type: 'linear',
          }]
        },
        responsive: true,
        legend: this.legend ? {
          position: 'bottom',
          align: 'start',
          labels: {
            usePointStyle: true,
            boxWidth: 8
          }
        } : false,
        maintainAspectRatio: false,
      }
    }
  },

  watch: {
    dataset(newVal) {
      if (newVal) {
        this.createChart();
      }
    }
  },

  mounted() {
    this.createChart();
  },

  methods: {
    createChart() {
      if (this.chart &&
          Object.keys(this.chart).length !== 0) {
        this.chart.destroy();
      }

      const data = {
        labels: [...this.labels],
        datasets: [this.dataset, this.baseline],
        borderSkipped: false,
      };

      console.log("Data: ", data);

      this.chart = new Chart(this.$refs.chart, {
        type: 'line',
        data: data,
        options: this.chartOptions,
      });
    }
  }
}
